import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed bottom-6 right-6 z-50 flex items-center gap-3 rounded-lg border border-border bg-card shadow-lg px-4 py-3 text-sm text-foreground",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_2 = {
  key: 0,
  class: "flex h-2 w-2 rounded-full bg-yellow-400 animate-pulse"
}
const _hoisted_3 = {
  key: 1,
  class: "flex h-2 w-2 rounded-full bg-blue-400 animate-spin"
}
const _hoisted_4 = {
  key: 2,
  class: "flex h-2 w-2 rounded-full bg-green-400"
}
const _hoisted_5 = {
  key: 3,
  class: "flex h-2 w-2 rounded-full bg-red-400"
}
const _hoisted_6 = { class: "font-medium" }

import { ref, watch } from 'vue'

interface Props {
  status: 'unsaved' | 'saving' | 'saved' | 'error'
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SaveStatusToast',
  props: {
    status: {}
  },
  setup(__props: any) {

const props = __props

const visible = ref(false)
let hideTimer: number | null = null

watch(
  () => props.status,
  (newStatus) => {
    visible.value = newStatus !== 'saved'

    if (newStatus === 'saved') {
      visible.value = true
      if (hideTimer) clearTimeout(hideTimer)
      hideTimer = window.setTimeout(() => (visible.value = false), 2500)
    }

    if (newStatus === 'error') {
      visible.value = true
      if (hideTimer) clearTimeout(hideTimer)
    }
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    "enter-active-class": "transition ease-out duration-300",
    "enter-from-class": "translate-y-4 opacity-0",
    "enter-to-class": "translate-y-0 opacity-100",
    "leave-active-class": "transition ease-in duration-200",
    "leave-from-class": "translate-y-0 opacity-100",
    "leave-to-class": "translate-y-4 opacity-0"
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.status === 'unsaved')
              ? (_openBlock(), _createElementBlock("span", _hoisted_2))
              : (_ctx.status === 'saving')
                ? (_openBlock(), _createElementBlock("span", _hoisted_3))
                : (_ctx.status === 'saved')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4))
                  : (_ctx.status === 'error')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5))
                    : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_6, [
              (_ctx.status === 'unsaved')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("Unsaved changes")
                  ], 64))
                : (_ctx.status === 'saving')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("Saving…")
                    ], 64))
                  : (_ctx.status === 'saved')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode("All changes saved")
                      ], 64))
                    : (_ctx.status === 'error')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _createTextVNode("Failed to save changes")
                        ], 64))
                      : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})